import { TBackofficeGroupResourceItem } from '@/backoffice/features/groups/hooks/use-backoffice-group-resource-update-promises.types';
import { TGroupResourceItem } from '@/shared/features/groups/context/groups-config-context.types';

export const isBackofficeGroupResourceItem = (
  resource: TGroupResourceItem,
): resource is TBackofficeGroupResourceItem =>
  resource.__typename === 'SuperUserResponseType' ||
  resource.__typename === 'SuperUserRoleResponseType' ||
  resource.__typename === 'BackofficeResourceGroupResponseType' ||
  resource.__typename === 'TenantResponseType';
